import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getMonthTHFromInt, checkStatus } from '../../../util/util';

class NewsViewer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newsList: []
        };
        console.log('NewsViewer');
        //this.getNewsList=this.getNewsList.bind(this);
    }
    componentDidMount() {
        console.log('Posting request to GitHub API...');
        let currentComponent = this;
        fetch(this.props.url, {
            method: 'post',

        }).then(function (response) {
            return checkStatus(response);
        }).then(function (data) {
            console.log('Created Gist:', data);
            if (data.RESULT_DATA) {
                currentComponent.setState({
                    newsList: data.RESULT_DATA
                })
                if(currentComponent.props.onDataLoaded)
                    currentComponent.props.onDataLoaded(data.RESULT_DATA);
            }else{
                if(currentComponent.props.onDataLoaded)
                    currentComponent.props.onDataLoaded([]);
            }

        });
    }


    convertDate(date) {
        let d = date.split('-');
        return getMonthTHFromInt(parseInt(d[1])) + ' ' + (parseInt(d[0]) + 543);
    }

    render() {
        const { newsList } = this.state;
        let rows = [];
        let index = 1;
        newsList.map(news => {
            console.log("details", news.details);
            rows.push(
                <div>
                    <div  style = {{ color: "#000"}}>
                        {news.details}
                    </div>
                    <div style = {{fontSize: 12, color: "#bfbfbf"}}>
                        {this.convertDate(news.last_upd_dtm)}
                    </div>
                    <hr></hr>
                </div>
            )

        });




        return (<div>

            {rows}

        </div>

        );
    }
}
NewsViewer.propTypes = {
    url: PropTypes.string,

};
NewsViewer.defaultProps = {
    url: 'http://203.150.199.244/api/admin/getNewsList'
};
export default NewsViewer;


// WEBPACK FOOTER //
// ./src/app/view/components/Login/NewsViewer.js